if (!customElements.get('cart-product-recommendations')) {
	customElements.define('cart-product-recommendations', class CartProductRecommendations extends HTMLElement {
		constructor() {
			super();
      // this.handleRequests = [];
		}

		update() {
      // let results = [];
      // let resultIds = [];
			// let totalItem = 0;
      // this.limit = parseInt(this.dataset.limit);
      // this.classList.add('loading');
      // const loading = this.querySelector('.cart__recommendation-loading');
      // if(loading) {
      //   loading.classList.remove('hidden');
      // }
      // fetch(`${routes.cart_url}.js`)
      // .then(response => response.json())
      // .then(cart => {
      //   if(cart.item_count > 0) {
      //     const productIds = cart.items.map((item) => {
      //       return item.product_id;
      //     });
      //     const cartItemsLength = productIds.length;
      //     const limit = Math.round(parseFloat(this.limit / cartItemsLength)) + cartItemsLength - 1;
      //     productIds.forEach((pId, index) => {
      //       const url = `${this.dataset.url}?section_id=${this.dataset.sectionId}&product_id=${pId}&limit=${limit}`;
      //       const controller = new AbortController();
      //       const signal = controller.signal;
      //       this.handleRequests.push(controller);
      //       fetch(url, { signal })
      //         .then(response => response.text())
      //         .then(text => {debugger
      //           const resultList = getDomHtmlFromText(text, '.item-list');
      //           resultList.querySelectorAll(this.dataset.itemSelector).forEach((item, itemIndex) => {
      //             const itemId = item.dataset.productId;
      //             if(!resultIds.includes(itemId)) {
      //               results.push(item);
      //               resultIds.push(itemId);
      //             }
      //           });
      //           totalItem++;
      //           if(totalItem == cartItemsLength) {
      //             this.classList.remove('loading');
      //             this.renderResults(results);
      //           }
      //         });
      //     });
      //   } else {
      //     this.classList.remove('loading');
      //   }
      // });
    }

    renderResults(items) {
    //   if(this.querySelector('.cart__recommendation-loading')) {
    //     if(this.dataset.removeLoading) {
    //       this.querySelector('.cart__recommendation-loading').remove();
    //     } else {
    //       this.querySelector('.cart__recommendation-loading').classList.add('hidden');
    //     }
    //   }
    //   this.handleRequests = [];
    //   this.fisherYates(items);
    //   const finalItems = items.slice(0, this.limit);
    //   const list = this.querySelector('.cart__recommendation-list');
    //   if($(this).parents('.cart-drawer').length){
    //     $(list).html('')
    //     finalItems.forEach((item, index) => {
    //       $(list).append(item);
    //     });
    //   }else{
    //     const sliderComponent = document.createElement('slider-component');
    //     $(sliderComponent).addClass('block max-w-[var(--page-width)] mx-auto px-[1.5rem] relative pc:px-[var(--airiosoft-container-padding)]')
    //   sliderComponent.classList.add('slider-mobile-gutter', 'por');
    //   this.dataset.componentClasses.split(' ').forEach((htmlClass, indexClass) => {
    //     sliderComponent.classList.add(htmlClass);
    //   });
    //   sliderComponent.dataset.outsidePrevButtonId = `Slider-${this.dataset.sectionId}-prev-button`;
    //   sliderComponent.dataset.outsideNextButtonId = `Slider-${this.dataset.sectionId}-next-button`;
    //   const sliderList = document.createElement('ul');
    //   $(sliderList).addClass('!flex flex-wrap gap-x-[var(--grid-horizontal-spacing)] gap-y-[var(--grid-mobile-vertical-spacing)] mb-8 p-0 list-none [scrollbar-color:rgb(0,0,0)_rgba(0,0,0,.04)] [-ms-overflow-style:none] [scrollbar-width:none] m-0 pc:relative pc:flex-wrap-inherit pc:overflow-x-auto pc:overflow-y-hidden pc:snap-x-mandatory pc:scroll-smooth pc:[-webkit-overflow-scrolling:touch] pc:pt-[5rem] pc:pb-[calc(9rem-var(--product-card-shadow-position))] pc:mt-[-5rem] pc:mb-[calc(-9rem+var(--product-card-shadow-position))] pc:ml-[-5rem] pc:pl-[5rem] pc:[scroll-padding-left:5rem] pc:mr-[-5rem] pc:pr-[5rem] mobile:relative mobile:flex-wrap-inherit mobile:overflow-x-auto mobile:snap-x-mandatory mobile:scroll-smooth mobile:[-webkit-overflow-scrolling:touch]')
    //   sliderList.id = `Slider-${this.dataset.sectionId}`;
    //   sliderList.classList.add('grid');
    //   this.dataset.gridClasses.split(' ').forEach((htmlClass, indexClass) => {
    //     sliderList.classList.add(htmlClass);
    //   });
    //   finalItems.forEach((item, index) => {
    //     const sliderItem = document.createElement('li');
    //     $(sliderItem).addClass('[--focus-outline-padding:.5rem] snap-start flex-shrink-0 pb-0 w-[calc(50%-var(--grid-horizontal-spacing)/2)] mobile:mb-0 pc:mb-0 pc:w-[calc(25%-var(--grid-horizontal-spacing)*3/4)]')
    //     sliderItem.id = `Slide-${this.dataset.sectionId}-${(index + 1)}`;
    //     sliderItem.classList.add('grid__item', 'slider__slide');
    //     sliderItem.appendChild(item);
    //     sliderList.appendChild(sliderItem);
    //   });
    //   sliderComponent.appendChild(sliderList);
    //   list.innerHTML = '';
    //   list.appendChild(sliderComponent);
    //   sliderComponent.init();
    // }
  }

    fisherYates( array ){
      // var count = array.length, randomnumber, temp;
      // while( count ){
      //   randomnumber = Math.random() * count-- | 0;
      //   temp = array[count];
      //   array[count] = array[randomnumber];
      //   array[randomnumber] = temp
      // }
    }

    disconnectedCallback() {
      // if(this.handleRequests.length > 0) {
      //   this.classList.remove('loading');
      //   this.handleRequests.forEach((controller, index) => {
      //     controller.abort();
      //   });
      // }
    }
  });
}